<template>
    <div class="partner min-contain">
        <img src="../assets/other/about1.jpg" alt="">
        <div class="partner-main">
         <div>
            <div class="title">合作伙伴</div>
            <el-divider>PARTNERS</el-divider>
         </div>
            <div class="contain">
                <el-carousel trigger="click" ref="carouselRef" height="200px"  indicator-position="outside" interval="5000" arrow="always">
                    <el-carousel-item v-for="item in partnerInfo" :key="item">
                        <div v-for="v in item" :key="v" class="img-box">
                            <img :src="v" alt="">
                        </div>
                    </el-carousel-item>
                </el-carousel>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Partner',
    data() {
        return {
            partnerInfo: [
                [require('../assets/other/partner1.png'),
                require('../assets/other/partner2.jpg'),
                require('../assets/other/partner3.png'),
                require('../assets/other/partner4.jpg'),
                require('../assets/other/partner5.png')
                ],
                [require('../assets/other/partner11.png'),
                require('../assets/other/partner12.png'),
                require('../assets/other/partner13.png'),
                require('../assets/other/partner14.png'),
                require('../assets/other/partner15.png')
                ],
                [
                require('../assets/other/partner7.png'),
                require('../assets/other/partner8.png'),
                require('../assets/other/partner9.png'),
                require('../assets/other/partner10.png'),
                require('../assets/other/partner16.jpg'),
                ],
            
            ]
        }
    },
}
</script>

<style lang="less" scoped>
::v-deep .el-carousel__arrow--right{
    right: 30% !important;
   
}
::v-deep .el-carousel__arrow--left{
    left: 30%;
}
::v-deep .el-carousel__arrow{
    background: transparent;
    bottom: -64px !important;
    top: auto;
    
    i{
        font-size: 35px;
        color: rgb(240 241 243);
        font-weight: 900;
        &:hover{
            color: #C0C4CC;
        }
    }
}
.partner {
    img {
        height: 600px;
        min-height: 60vh;
        width: 100%;
        object-fit: cover;
    }

    .partner-main {
        background: #fff;
        padding: 30px 0;
        min-height: 40vh;
        display: flex;
        flex-direction: column;
        justify-content: center;

        .title {
            font-size: 24px;
            text-align: center;
            color: #000;
        }
        .el-carousel{
            padding: 60px 0;
        }

        .el-carousel__item {
            display: flex;
            justify-content: space-around;
        }

        ::v-deep .el-carousel__button  {
            width: 30px !important;
            height: 30px !important;
            border-radius: 50% !important;
            margin: 0 5px;
        }

        .img-box {
            width: 15%;
            height: 100px;
            border: 1px solid #D7D7D7;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        img {
            width: 60%;
            height: 70px;
            border-radius: 8px;
            object-fit: contain;
        }
    }
}
</style>